import { setToken, setUserId } from "@/helpers/localStorage";
import { useWeb3Auth } from "@web3auth/modal-react-hooks";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import SignInHeaderTelegramBtn from "./sign-in-header-telegram-btn";

const Web3AuthButtonInjector = () => {
  const [container, setContainer] = useState<HTMLElement | null>(null);
  const { web3Auth, isConnected } = useWeb3Auth();

  useEffect(() => {
    const checkAndSetContainer = () => {
      const target = document.querySelector(
        ".w3a-adapter-list.w3ajs-socials-adapters.w3a-adapter-list--shrink",
      );

      if (target && !document.getElementById("custom-telegram-button")) {
        setContainer(target as HTMLElement);
      }
    };

    checkAndSetContainer(); // check immediately on mount

    const observer = new MutationObserver(() => {
      checkAndSetContainer();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const initWithWeb3Auth = async () => {
      if (!web3Auth || !isConnected) {
        return;
      }
      const { verifierId } = await web3Auth.getUserInfo();
      const { idToken } = await web3Auth.authenticateUser();

      setUserId(verifierId || "");
      setToken(idToken || "");
    };
    initWithWeb3Auth();
  }, [web3Auth, isConnected]);

  if (!container) return null;

  return createPortal(<SignInHeaderTelegramBtn />, container);
};

export default Web3AuthButtonInjector;
